export const metatagimapaserwisu = {
  Page: {
    "meta-tagi": {
      Title: "TravelOne.pl - mapa serwisu",
      Description:
        "Mapa serwisu TravelOne.pl. Wszystkie linki, strony i podstrony portalu TravelOne.pl. Pełna mapa serwisu ::: Zaplanuj idealne wakacje z Grupą Portali TravelOne.pl!",
      Keywords: []
    }
  }
};
